import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
/*
Single select dropdown with option for another text field to show,
when 'other' is selected, allowing for custom response
*/
import { useState, useEffect } from "react";
import { RSForm } from "../index";
import { SingleSelect, FormTextField } from "./index";
function SingleSelectCustomOption(props) {
    const { id, value, setValue, data, label, customOptionPlaceholder } = props;
    const [selectedOption, setSelectedOption] = useState("");
    const [customValue, setCustomValue] = useState("");
    const [showCustomBox, setShowCustomBox] = useState(false);
    useEffect(() => {
        if (!value && selectedOption !== "Other") {
            setSelectedOption("");
            setCustomValue("");
            setShowCustomBox(false);
        }
        else if (data.includes(value)) {
            setSelectedOption(value);
            setShowCustomBox(false);
            setCustomValue("");
        }
        else {
            setSelectedOption("Other");
            setCustomValue(value);
            setShowCustomBox(true);
        }
    }, [value, data]);
    const handleSelectChange = (newValue) => {
        setSelectedOption(newValue);
        if (newValue === "Other" || newValue === "other") {
            setShowCustomBox(true);
            if (!data.includes(value)) {
                setCustomValue(value);
            }
            else {
                setCustomValue("");
                setValue("");
            }
        }
        else {
            setShowCustomBox(false);
            setCustomValue("");
            setValue(newValue);
        }
    };
    const handleCustomValueChange = (newValue) => {
        setCustomValue(newValue);
        setValue(newValue);
    };
    return (_jsx(_Fragment, { children: _jsxs(RSForm.Group, { controlId: `form${label ? label.replace(/\s+/, "") : "OtherOptionSelect"}`, children: [_jsx(RSForm.ControlLabel, { children: label || "Please select from the dropdown below..." }), _jsx(SingleSelect, { data: data, placeholder: "Please Select...", value: selectedOption, setValue: handleSelectChange, block: true }), showCustomBox && (_jsx(FormTextField, { id: `form-${id}-custom-${label}`, name: `custom${label ? label.replace(/\s+/, "") : "FormTextField"}`, label: `Other ${label || "Option"}`, placeholder: `${customOptionPlaceholder || "Please enter a custom option..."}`, value: customValue, onChange: handleCustomValueChange }))] }) }));
}
export default SingleSelectCustomOption;
